import { render, staticRenderFns } from "./tableWrap.vue?vue&type=template&id=0856a883&scoped=true&"
import script from "./tableWrap.vue?vue&type=script&lang=ts&"
export * from "./tableWrap.vue?vue&type=script&lang=ts&"
import style0 from "./tableWrap.vue?vue&type=style&index=0&id=0856a883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856a883",
  null
  
)

export default component.exports